import axios from 'axios'

export default {
  getTracking(barcode) {
    return axios.get(`/client-webform/tracking/${barcode}`);
  }
}



// WEBPACK FOOTER //
// ./src/api/Tracking.js